@use "~theme/typography.scss";
@use "~theme/breakpoints.scss";
@use "~components/LegacyCard/tokens.scss" as Card;

.card {
  padding: 28px 24px;
  flex: 1;
  max-width: Card.$max-width;

  @include breakpoints.desktop {
    padding: 40px 32px;
  }
}

.container {
  display: flex;
  flex-direction: column;
  padding: 0;
}

.header {
  @include typography.heading3;
  margin: 0;
  text-align: center;
}

.body {
  @include typography.body;
  text-align: center;
  margin: 0;
}

.buttonContainer {
  display: flex;
  margin: 40px 0 20px;
}
